"use strict";
exports.__esModule = true;
exports.Category = void 0;
var Category;
(function (Category) {
    Category["Case"] = "case";
    Category["Event"] = "event";
    Category["Focus"] = "focus";
    Category["InnerPage"] = "inner-page";
    Category["Interview"] = "interview";
    Category["KeysFigures"] = "keys-figures";
    Category["Lifespiration"] = "lifespiration";
    Category["Misconception"] = "misconception";
    Category["PointOfView"] = "point-of-view";
    Category["Portrait"] = "portrait";
    Category["Services"] = "services";
    Category["Publication"] = "publication";
    Category["PublicationDownloadable"] = "publication-downloadable";
    Category["RightNow"] = "right-now";
})(Category = exports.Category || (exports.Category = {}));
//# sourceMappingURL=category.js.map